import React from "react";
import {RouteObject} from "react-router-dom";
import TicketsLayout from "../../layout/TicketsLayout/TicketsLayout";

const TicketsRoutes : RouteObject[] = [
    {
        path:'tickets',
        element:<TicketsLayout/>
    }
]

export default TicketsRoutes;